export const PartsIssueDetailsLabel = "Parts Issue Details";
export const AddPartIssueDetailsLabel = "Add Part Issue Details";
export const EditPartIssueDetailsLabel = "Edit Part Issue Details";
export const viewPartIssueDetailsLabel = "View Part Issue Details";
export const historyOfPartIssueDetailsLabel = "History of Part Issue Details";
export const PART_ISSUE_NO_LABEL = "Part Issue No."
export const NewLabel = "New";
